import * as React from "react";
import classnames from "classnames";
import { Heading, Text, Button } from "@grandvisionhq/elements";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import AlternativeStoreSuggestionsContainer from "../../../../AlternativeStoreSuggestions/v3/components/AlternativeStoreSuggestions/AlternativeStoreSuggestionsContainer.js";
import AvailabilityCalendarContainer from "../../../../AvailabilityCalendar/v3/components/AvailabilityCalendar/AvailabilityCalendarContainer.js";
import AppointmentInfoContainer from "../../../../LinkedAppointmentInfo/v3/components/LinkedAppointmentInfo/LinkedAppointmentInfoContainer.js";
import NoTimeSlotsContainer from "../../../../NoTimeSlots/v3/components/NoTimeSlots/NoTimeSlotsContainer.js";
import { Variant } from "../../../../NoTimeSlots/v3/components/NoTimeSlots/types.js";
import PreferredTimeContainer from "../../../../PreferredTime/v3/components/PreferredTime/PreferredTimeContainer.js";
import SelectedChoicesContainer from "../../../../SelectedChoices/v3/components/SelectedChoices/SelectedChoicesContainer.js";
import TimeSlotsContainer from "../../../../TimeSlots/v3/components/TimeSlots/TimeSlotsContainer.js";
/* empty css                         */
const AppointmentDateTime = ({
  className,
  labels,
  calendarLoading,
  calendarWeekCount,
  calendarWeekDate,
  calendarAvailability,
  calendarClosedDates,
  store,
  appointmentType,
  shouldRequestAlternativeStoreSuggestions = false,
  selectedDate,
  onCalendarWeeksChange,
  onSelectDate,
  timeSlotsLoading,
  noTimeSlotsVariant,
  timeSlots,
  showOtherTimeSlots,
  otherTimeSlots,
  onSelectTime,
  onToggleOtherTimeSlots,
  nextAvailableDate,
  noMoreAvailabilityUntilDate,
  noTimeSlotsAction,
  onSelectStore,
  onPreferredTimeClick,
  onPreferredTimeFilterClick,
  isAabAlternativeStoreAvailabilityEnabled = false,
  hasNoTimeSlotsAvailableInCalendar,
  isVirtualappointment,
  otherTimeSlotsElement,
  ...rest
}) => {
  const intl = useIntl();
  const {
    dateTime: { formatDate }
  } = intl;
  const hasTimeSlots = timeSlots.length > 0;
  const hasOtherTimeSlots = otherTimeSlots.length > 0;
  const noTimeSlotsComponent = hasNoTimeSlotsAvailableInCalendar ? /* @__PURE__ */ React.createElement(
    NoTimeSlotsContainer,
    {
      variant: noTimeSlotsVariant,
      action: noTimeSlotsAction,
      nextAvailableDate,
      noAvailabilityUntilDate: noMoreAvailabilityUntilDate
    }
  ) : null;
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("appointment-date-time", className) }, /* @__PURE__ */ React.createElement(SelectedChoicesContainer, null), /* @__PURE__ */ React.createElement(AppointmentInfoContainer, null), /* @__PURE__ */ React.createElement(Heading, { component: "h3", variant: "smallest", className: "appointment-date-time__title" }, labels.title), /* @__PURE__ */ React.createElement(
    PreferredTimeContainer,
    {
      onPreferredTimeClick,
      onPreferredTimeFilterClick,
      calendar: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        AvailabilityCalendarContainer,
        {
          "aria-controls": "appointment-date-time__timeslots",
          loading: calendarLoading,
          weekCount: calendarWeekCount,
          weekDate: calendarWeekDate,
          availability: calendarAvailability,
          closedDates: calendarClosedDates,
          selectedDate,
          onChangeWeeks: onCalendarWeeksChange,
          onSelectDate,
          noTimeSlots: noTimeSlotsComponent
        }
      ), selectedDate && !hasNoTimeSlotsAvailableInCalendar && /* @__PURE__ */ React.createElement(Text, { className: "appointment-date-time__selected-date" }, formatDate(selectedDate, "long")))
    }
  ), /* @__PURE__ */ React.createElement("section", { id: "appointment-date-time__timeslots", "aria-live": "polite" }, noTimeSlotsVariant === Variant.none ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Heading,
    {
      component: "h4",
      variant: "subheading1",
      className: "appointment-date-time__section-title"
    },
    labels.selectATime
  ), /* @__PURE__ */ React.createElement("p", { className: "appointment-date-time__section-subtitle" }, labels.selectATimeSubtitle), /* @__PURE__ */ React.createElement(
    TimeSlotsContainer,
    {
      loading: timeSlotsLoading || calendarLoading,
      slots: timeSlots,
      onSelectTime
    }
  )) : /* @__PURE__ */ React.createElement(React.Fragment, null, !hasNoTimeSlotsAvailableInCalendar ? /* @__PURE__ */ React.createElement(
    Alert,
    {
      className: "alert-m-default no-time-slots",
      variant: noTimeSlotsVariant === Variant.error ? "warning" : "info"
    },
    /* @__PURE__ */ React.createElement(
      NoTimeSlotsContainer,
      {
        variant: noTimeSlotsVariant,
        action: noTimeSlotsAction,
        nextAvailableDate,
        noAvailabilityUntilDate: noMoreAvailabilityUntilDate
      }
    )
  ) : null), hasOtherTimeSlots && /* @__PURE__ */ React.createElement(React.Fragment, null, hasTimeSlots && /* @__PURE__ */ React.createElement(
    Button,
    {
      className: "appointment-date-time__show-other-time-slots",
      variant: "ghost",
      onClick: onToggleOtherTimeSlots
    },
    showOtherTimeSlots ? labels.hideOtherTimeSlots : labels.showOtherTimeSlots
  ), showOtherTimeSlots && /* @__PURE__ */ React.createElement("div", { ref: otherTimeSlotsElement, className: "appointment-date-time__other-time-slots" }, !hasTimeSlots && /* @__PURE__ */ React.createElement(
    Heading,
    {
      component: "h4",
      variant: "subheading1",
      className: "appointment-date-time__section-title"
    },
    labels.otherTimeSlots
  ), /* @__PURE__ */ React.createElement(
    TimeSlotsContainer,
    {
      loading: timeSlotsLoading || calendarLoading,
      slots: otherTimeSlots,
      onSelectTime
    }
  )))), isAabAlternativeStoreAvailabilityEnabled && !isVirtualappointment && /* @__PURE__ */ React.createElement(
    "section",
    {
      id: "appointment-date-time__alternative-store-suggestions",
      className: "appointment-date-time__with-secondary-background",
      "aria-live": "polite"
    },
    /* @__PURE__ */ React.createElement(
      AlternativeStoreSuggestionsContainer,
      {
        selectedStore: store ?? void 0,
        selectedDate,
        requestStoresFromParent: shouldRequestAlternativeStoreSuggestions,
        onClickStore: onSelectStore
      }
    )
  ));
};
export {
  AppointmentDateTime as default
};
//# sourceMappingURL=AppointmentDateTime.js.map
